<template>
    <ul style="list-style:none; padding-left:0">
        <li v-for="(amount, roomType) in roomTypes" :key="roomType">
            {{amount}}x {{roomType}}
        </li>
    </ul>
</template>

<script>
    export default {
        props: {
            roomTypes: {
                type: Object,
            },
        },
    };
</script>
